var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#393939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3845_17102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 14.3809C22.837 14.3809 22.2011 14.6443 21.7322 15.1131C21.2634 15.5819 21 16.2178 21 16.8809V23.5475C21 24.2106 21.2634 24.8465 21.7322 25.3153C22.2011 25.7841 22.837 26.0475 23.5 26.0475C24.163 26.0475 24.7989 25.7841 25.2678 25.3153C25.7366 24.8465 26 24.2106 26 23.5475V16.8809C26 16.2178 25.7366 15.5819 25.2678 15.1131C24.7989 14.6443 24.163 14.3809 23.5 14.3809V14.3809Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 14.3809C22.837 14.3809 22.2011 14.6443 21.7322 15.1131C21.2634 15.5819 21 16.2178 21 16.8809V23.5475C21 24.2106 21.2634 24.8465 21.7322 25.3153C22.2011 25.7841 22.837 26.0475 23.5 26.0475C24.163 26.0475 24.7989 25.7841 25.2678 25.3153C25.7366 24.8465 26 24.2106 26 23.5475V16.8809C26 16.2178 25.7366 15.5819 25.2678 15.1131C24.7989 14.6443 24.163 14.3809 23.5 14.3809V14.3809Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3346 21.8809V23.5475C29.3346 25.0946 28.7201 26.5784 27.6261 27.6723C26.5321 28.7663 25.0484 29.3809 23.5013 29.3809C21.9542 29.3809 20.4705 28.7663 19.3765 27.6723C18.2826 26.5784 17.668 25.0946 17.668 23.5475V21.8809",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3346 21.8809V23.5475C29.3346 25.0946 28.7201 26.5784 27.6261 27.6723C26.5321 28.7663 25.0484 29.3809 23.5013 29.3809C21.9542 29.3809 20.4705 28.7663 19.3765 27.6723C18.2826 26.5784 17.668 25.0946 17.668 23.5475V21.8809",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29.3809V32.7142",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29.3809V32.7142",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.168 32.7129H26.8346",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.168 32.7129H26.8346",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3845_17102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.5 13.5469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.434cd7268146c4da3c57c2de1ce40cee.svg";
export { ForwardRef as ReactComponent };